document.addEventListener("DOMContentLoaded", () => {
    const slides = document.querySelectorAll(".slidev8");

    // Función para verificar si un elemento está en el viewport
    function isInViewport(element) {
        const rect = element.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }

    // Auto-play cuando el video entra en el viewport
    function handleScroll() {
        slides.forEach(slide => {
            const video = slide.querySelector("video");
            const playButton = slide.querySelector(".play-buttonv8");
            const pauseButton = slide.querySelector(".pause-buttonv8");
            if (isInViewport(slide)) {
                // Pausa todos los demás videos
                document.querySelectorAll("video").forEach(v => {
                    if (v !== video) {
                        v.pause();
                        v.classList.remove("playingv8");
                        const s = v.closest('.slidev8');
                        if (s) {
                            const pb = s.querySelector('.play-buttonv8');
                            const ppb = s.querySelector('.pause-buttonv8');
                            if (pb) pb.style.display = "flex";
                            if (ppb) ppb.style.display = "none";
                        }
                    }
                });
                // Solo auto-play si no está ya reproduciéndose
                if (video.paused) {
                    video.play().catch(() => {});
                    video.classList.add("playingv8");
                    playButton.style.display = "none";
                    pauseButton.style.display = "flex";
                }
            } else {
                video.pause();
                video.classList.remove("playingv8");
                playButton.style.display = "flex";
                pauseButton.style.display = "none";
            }
        });
    }

    // Eventos de scroll y resize
    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleScroll);
    // Llamada inicial
    handleScroll();

    slides.forEach(slide => {
        const playButton = slide.querySelector(".play-buttonv8");
        const pauseButton = slide.querySelector(".pause-buttonv8");
        const video = slide.querySelector("video");

        let hidePauseButtonTimeout;

        const showPauseButton = () => {
            pauseButton.classList.remove("hiddenv8");
            clearTimeout(hidePauseButtonTimeout);
            hidePauseButtonTimeout = setTimeout(() => {
                pauseButton.classList.add("hiddenv8");
            }, 1000);
        };

        playButton.addEventListener("click", () => {
            // Pause other videos
            document.querySelectorAll("video").forEach(v => {
                if (v !== video) {
                    v.pause();
                    v.classList.remove("playingv8");
                }
            });

            // Play selected video
            video.play();
            video.classList.add("playingv8");
            playButton.style.display = "none";
            pauseButton.style.display = "flex";
            showPauseButton();
        });

        pauseButton.addEventListener("click", () => {
            video.pause();
            video.classList.remove("playingv8");
            playButton.style.display = "flex";
            pauseButton.style.display = "none";
        });

        video.addEventListener("mousemove", showPauseButton);
        video.addEventListener("click", showPauseButton);

        video.addEventListener("play", () => {
            playButton.style.display = "none";
            pauseButton.style.display = "flex";
            showPauseButton();
        });

        video.addEventListener("pause", () => {
            playButton.style.display = "flex";
            pauseButton.style.display = "none";
        });
    });
}); 